export enum TABLE_EVENT {
    ROW_CHANGED = 'ROW_CHANGED',
    ROW_CLICKED = 'ROW_CLICKED',
}
